import { render } from "./TaskDetails.vue?vue&type=template&id=2bcd1503&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=2bcd1503&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bcd1503"

export default script